<label class="switch">
  <input type="checkbox" [checked]="checked">
  <span class="slider"></span>
</label>
